import { Component, OnInit, Inject } from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';

@Component({
  selector: 'app-snack-alerta',
  templateUrl: './snack-alerta.component.html',
  styleUrls: ['./snack-alerta.component.scss'],
})
export class SnackAlertaComponent implements OnInit {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private snackRef: MatSnackBarRef<SnackAlertaComponent>
  ) {}

  ngOnInit(): void {}
  close() {
    this.snackRef.dismiss();
  }
}
